<div class="tokushou">
  <h3 id="notices-by-scta">特定商取引法に基づく表記</h3>
  <h4 id="scta-legal-name">事業者名</h4>
  <p>Nameraka .inc</p>
  <h4 id="scta-address">所在地</h4>
  <p>222-0024 神奈川県横浜市港北区篠原台町38-15</p>
  <h4 id="scta-head-of-operator">運営統括責任者</h4>
  <p>Shogo Takeuchi</p>
  <h4 id="notices-by-scta-contact">お問い合わせ</h4>
  <ul>
    <li>
      メールアドレス: <a href="mailto:aifan.support@nameraka.co.jp" target="_blank">aifan.support@nameraka.co.jp</a>
    </li>
    <li>電話番号：<a href="tel:05088885968">050-8888-5968</a> 受付時間 14:00-18:00（土日祝を除く）</li>
  </ul>
  <h4 id="notices-by-additional-fee">追加手数料等の追加料金</h4>
  <ul>
    <li>処理手数料 100円</li>
    <li>振り込み手数料 200円</li>
    <li>プラットフォーム手数料 総支援額の10%</li>
  </ul>
  <h4 id="notices-by-scta-refunding">返金ポリシー</h4>
  <p>
    支援契約の成立後の返金はできません。途中の解約となった場合も1ヶ月分の料金が発生し、日割清算等による返金を含めた一切の返金は行われません。
  </p>
  <h4 id="scta-delivery-time">引渡時期</h4>
  <p>あるプランの支援契約の成立後すぐにそのプランに対応したアーティストの投稿を閲覧できます。</p>
  <h4 id="scta-price">支援価格</h4>
  <p>各プランに表示</p>
  <h4 id="scta-payment-period">決済時期</h4>
  <p>初支援時はただちに処理されます。翌月以降分は月額払いです。</p>
  <h4 id="scta-accepted-payment-method">受け付け可能な決済手段</h4>
  <ul>
    <li>クレジットカード</li>
  </ul>
  <h4 id="notices-by-scta-conditions-of-canceling">解約条件</h4>
  <p>
    解約は契約期間内のいつでも行うことができます。 解約は<a href="/supporting" target="_blank">こちらのプラン一覧画面</a
    >で行うことができます。
    お申込み日から数えて翌月同日の前日まで、またはお申込み日が月末である場合には翌月末の一日前までにクレジットカードの解約を完了すれば、
    次の月のサービス提供および課金は発生しません。例えば、6月10日に契約した場合、解約期限は7月9日までとなります。
    また、月末日が翌月に存在しない8月31日に契約した場合、解約期限は9月29日までとなります。
  </p>
</div>
